// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__-R4V6","links":"Header_links__OcHSY"};